import { React, useState, useEffect } from 'react'
import "./header.css"
import { connect, useDispatch } from "react-redux"
import Select from "react-select";
import { Link } from 'react-router-dom';
import { logout } from '../../../Redux/actions';
import { useSelector } from 'react-redux';
import { getProfile, getName, getCompany, getUserName } from '../../../Redux/selecters';
import Avatar from "../../Assets/Images/avatar.png"
import { clearCompanies, updateCompany, updateSelectedCompany } from '../../../Redux/actions/companiesAction';
import { saveLogin, setUserRole } from "../../../Redux/actions";
import userManagement from "../../../POS/services/userManagement";
import { invokeLogin } from "../../../POS/services/signalRService";
import { setCompanies } from "../../../Redux/actions/companiesAction";
import ApiService from '../../../INVENTORY/services/apiService';
import { useNavigate } from 'react-router-dom';

const PMHeader = ({ Currency }) => {
    const dispatch = useDispatch()
    const fulname = useSelector(getName);
    const [userName, setUsername] = useState(fulname)
    const Name = useSelector(getUserName);
    const companies = useSelector(getCompany);
    const apiService = new ApiService();
    let navigate = useNavigate();
    const image = useSelector(getProfile);
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
        db: '',
        baseDb: ''
    });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };
    const closeDropdown = () => {
        setIsDropdownOpen(false);
    };

    const [financialYear, setFinancialYear] = useState([]);
    const [activeFY, setActiveFY] = useState(null);

    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        setFinancialYear(financialYears);

        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.InvProfile')) {
                closeDropdown();
            }
        };
        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    }, []);
    useEffect(() => {
        const url = window.location.href;
        const regex = /_username=([^&]+)&_password=([^&]+)&_db=([^&]+)&_baseDb=([^&]+)/;
        const match = url?.match(regex);
        if (match) {
            handleLogin({
                username: match[1],
                password: match[2],
                db: match[3],
                baseDb: match[4]
            })
        }
    }, []);
    useEffect(() => {
        if (!userName) {
            dispatch(clearCompanies());
        }
    }, [userName]);
    const handleLogin = async (first) => {
        dispatch(logout());
        dispatch(clearCompanies());
        localStorage.clear();

        let token = localStorage.getItem("Token")
        if (!token) {
            let body = {
                email: credentials?.username || first?.username,
                password: credentials?.password || first?.password,
                basedb: credentials?.baseDb || first?.baseDb,
                supportdb: credentials?.db || first?.db
            };
            try {
                const response = await apiService.post("GET_ENCRYPT_TOKEN", body);
                
                if (response && response.status === 200) {
                    dispatch(saveLogin(response?.data))
                    const userRole = userManagement.getUserRole(response?.data?.data?.accessToken);
                    dispatch(setUserRole(userRole))
                    localStorage.setItem('Token', response?.data?.data?.accessToken)
                    localStorage.setItem('Refresh_Token', response?.data?.data?.refreshToken)
                    const userCompanies = response?.data?.data?.userCompanies;
                    dispatch(setCompanies(userCompanies));
                    localStorage.setItem('UserCompanies', JSON.stringify(userCompanies));
                    let selectedCompany = userCompanies.find((comp) => comp.dataDB === response?.data?.data?.dataDb)
                    const userId = userManagement.getUserId(response?.data?.data?.userCompanies);
                    if (userId) {
                        invokeLogin(userId);
                    }
                    if (selectedCompany) {
                        dispatch(updateSelectedCompany(selectedCompany));
                        setSelectedCompany({ label: selectedCompany?.companyName, value: selectedCompany });
                        localStorage.setItem('DataBase', selectedCompany?.dataDB);
                        let param = `?username=${response?.data?.data?.userName}&companyNo=${selectedCompany?.companyNo}`
                        const res = await apiService.getApiParamater("GET_PERMISSIONS", param);
                        const permissions = res?.data?.data.filter((per) => per.moduleName === "Property Management");
                        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
                        const finres = await apiService.get('GET_FINANCIAL_YEAR');
                        let years = finres?.data?.data
                        localStorage.setItem('financialYear', JSON.stringify(years));
                        setFinancialYear(years)
                        navigate("/")
                    }

                    window.location.reload();
                } else if (response.status == false) {
                    localStorage.clear();
                    window.location.href = 'https://app.pro360erp.com/';
                }
            } catch (error) {
                console.log(error, "errrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr");
            }
        }

    };
    useEffect(() => {
        if (companies?.companies?.length) {
            
            let DB = localStorage.getItem('DataBase');
            let defaultCompany = companies?.companies.find((comp) => comp.dataDB === DB)
            setSelectedCompany({ label: defaultCompany?.companyName, value: defaultCompany });
            localStorage.setItem('DataBase', defaultCompany?.dataDB);
            dispatch(updateSelectedCompany(defaultCompany));
        }
    }, [companies?.companies, dispatch]);

    const handleDBChange = async (selectedOption) => {
        setSelectedCompany(selectedOption);
        dispatch(updateCompany(0, selectedOption.value));
        localStorage.setItem('DataBase', selectedOption?.value?.dataDB);
        let param = `?username=${Name}&companyNo=${selectedOption?.value?.companyNo}`

        const res = await apiService.getApiParamater("GET_PERMISSIONS", param);
        const permissions = res?.data?.data.filter((per) => per.moduleName === "Property Management");
        localStorage.setItem('RoleAccess', JSON.stringify(permissions));
        window.location.reload();
    };

    const handleOut = () => {
        dispatch(logout());
        dispatch(clearCompanies());
        localStorage.clear();
        window.location.href = 'https://app.pro360erp.com/';
    };
    const UserName = userName?.length > 20 ? userName.substring(0, 10) + '...' : userName;
   
    return (
        <nav class="navbar-expand-lg  invHead ">
            <div class="container-fluid">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse gap-4" id="navbarSupportedContent">
                    <div className="col-3 heading-title">Property Management</div>
                    <div className='end col-4 d-flex gap-2'>
                        <div className='center header-label'>Financial Year</div>
                        <Select
                            isSearchable={false}
                            options={financialYear?.map(comp => ({ value: comp, label: comp?.name }))}
                            className="w-75 p-0"
                            value={activeFY}
                            // isDisabled
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 8,
                                padding: 9,
                            })}
                        />
                    </div>
                    <div className='end col-2 d-fex'>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 8,
                                padding: 9
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            className="w-75 p-0"
                            onChange={handleDBChange}
                            value={selectedCompany} isDisabled
                            options={companies?.companies?.map(comp => ({ value: comp, label: comp?.companyName }))}
                        />
                    </div>
                    <div className="d-flex end gap-2">
                        <div className="invprofileimg">
                            {image ? (
                                <img src={image || Avatar} className="Invboxicon" alt="Profile" />
                            ) : (
                                <img src={Avatar} className="Invboxicon" alt="Avatar" />
                            )}
                        </div>
                        <div className="InvProfile dropdown">
                            <div onClick={toggleDropdown} className="dropdown-toggle">
                                {userName || "No-User"}
                            </div>
                            {isDropdownOpen && (
                                <div className="dropdown-content-stats pt-1">
                                    <Link to="/admin/Setting/Profile" className="p-2">Setting</Link>
                                    <Link onClick={handleOut} className="p-2">Log Out</Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    )
}


const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(PMHeader);